import React from 'react';
import { FaTable, FaEye } from 'react-icons/fa';

function DataSummaryCard({ data, onViewFull, title = "Data Results" }) {
    if (!data || data.length === 0) return null;

    const summary = {
        totalRecords: data.length,
        columns: Object.keys(data[0]),
        sampleRows: data.slice(0, 3)
    };

    const styles = {
        card: {
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            padding: '12px',
            margin: '8px 0'
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
        },
        title: {
            fontSize: '14px',
            fontWeight: '600',
            color: '#495057'
        },
        viewButton: {
            backgroundColor: '#0c022f',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '4px 8px',
            fontSize: '12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        },
        stats: {
            fontSize: '12px',
            color: '#6c757d',
            marginBottom: '8px'
        },
        preview: {
            fontSize: '11px',
            color: '#495057'
        },
        sampleRow: {
            backgroundColor: 'white',
            padding: '4px 8px',
            margin: '2px 0',
            borderRadius: '4px',
            display: 'flex',
            gap: '12px',
            overflow: 'hidden'
        },
        sampleItem: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    };

    return (
        <div style={styles.card}>
            <div style={styles.header}>
                <div style={styles.title}>
                    <FaTable style={{ marginRight: '6px' }} />
                    {title}
                </div>
                <button style={styles.viewButton} onClick={onViewFull}>
                    <FaEye /> View Full
                </button>
            </div>

            <div style={styles.stats}>
                {summary.totalRecords} records • {summary.columns.length} columns
            </div>

            <div style={styles.preview}>
                {summary.sampleRows.map((row, i) => (
                    <div key={i} style={styles.sampleRow}>
                        {summary.columns.slice(0, 3).map(col => (
                            <span key={col} style={styles.sampleItem}>
                                <strong>{col}:</strong> {row[col]}
                            </span>
                        ))}
                        {summary.columns.length > 3 && <span>...</span>}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DataSummaryCard;